/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LocalTime } from './LocalTime';
import {
    LocalTimeFromJSON,
    LocalTimeFromJSONTyped,
    LocalTimeToJSON,
} from './LocalTime';
import type { PartnerStationDtoTimeZone } from './PartnerStationDtoTimeZone';
import {
    PartnerStationDtoTimeZoneFromJSON,
    PartnerStationDtoTimeZoneFromJSONTyped,
    PartnerStationDtoTimeZoneToJSON,
} from './PartnerStationDtoTimeZone';

/**
 * 
 * @export
 * @interface PartnerStationDto
 */
export interface PartnerStationDto {
    /**
     * 
     * @type {PartnerStationDtoTimeZone}
     * @memberof PartnerStationDto
     */
    timeZone: PartnerStationDtoTimeZone;
    /**
     * 
     * @type {Set<Date>}
     * @memberof PartnerStationDto
     */
    publicHolidays: Set<Date>;
    /**
     * 
     * @type {Set<string>}
     * @memberof PartnerStationDto
     */
    weekDaysOpened: Set<PartnerStationDtoWeekDaysOpenedEnum>;
    /**
     * 
     * @type {LocalTime}
     * @memberof PartnerStationDto
     */
    openingTime: LocalTime;
    /**
     * 
     * @type {LocalTime}
     * @memberof PartnerStationDto
     */
    closingTime: LocalTime;
    /**
     * 
     * @type {number}
     * @memberof PartnerStationDto
     */
    maxBookingDays: number;
    /**
     * 
     * @type {Date}
     * @memberof PartnerStationDto
     */
    earliestPossiblePickup: Date;
    /**
     * 
     * @type {Date}
     * @memberof PartnerStationDto
     */
    latestPossiblePickup: Date;
    /**
     * 
     * @type {string}
     * @memberof PartnerStationDto
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerStationDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerStationDto
     */
    email: string;
}


/**
 * @export
 */
export const PartnerStationDtoWeekDaysOpenedEnum = {
    MONDAY: 'MONDAY',
    TUESDAY: 'TUESDAY',
    WEDNESDAY: 'WEDNESDAY',
    THURSDAY: 'THURSDAY',
    FRIDAY: 'FRIDAY',
    SATURDAY: 'SATURDAY',
    SUNDAY: 'SUNDAY'
} as const;
export type PartnerStationDtoWeekDaysOpenedEnum = typeof PartnerStationDtoWeekDaysOpenedEnum[keyof typeof PartnerStationDtoWeekDaysOpenedEnum];


/**
 * Check if a given object implements the PartnerStationDto interface.
 */
export function instanceOfPartnerStationDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "timeZone" in value;
    isInstance = isInstance && "publicHolidays" in value;
    isInstance = isInstance && "weekDaysOpened" in value;
    isInstance = isInstance && "openingTime" in value;
    isInstance = isInstance && "closingTime" in value;
    isInstance = isInstance && "maxBookingDays" in value;
    isInstance = isInstance && "earliestPossiblePickup" in value;
    isInstance = isInstance && "latestPossiblePickup" in value;
    isInstance = isInstance && "address" in value;
    isInstance = isInstance && "phoneNumber" in value;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function PartnerStationDtoFromJSON(json: any): PartnerStationDto {
    return PartnerStationDtoFromJSONTyped(json, false);
}

export function PartnerStationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerStationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timeZone': PartnerStationDtoTimeZoneFromJSON(json['timeZone']),
        'publicHolidays': json['publicHolidays'],
        'weekDaysOpened': json['weekDaysOpened'],
        'openingTime': LocalTimeFromJSON(json['openingTime']),
        'closingTime': LocalTimeFromJSON(json['closingTime']),
        'maxBookingDays': json['maxBookingDays'],
        'earliestPossiblePickup': (new Date(json['earliestPossiblePickup'])),
        'latestPossiblePickup': (new Date(json['latestPossiblePickup'])),
        'address': json['address'],
        'phoneNumber': json['phoneNumber'],
        'email': json['email'],
    };
}

export function PartnerStationDtoToJSON(value?: PartnerStationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timeZone': PartnerStationDtoTimeZoneToJSON(value.timeZone),
        'publicHolidays': Array.from(value.publicHolidays as Set<any>),
        'weekDaysOpened': Array.from(value.weekDaysOpened as Set<any>),
        'openingTime': LocalTimeToJSON(value.openingTime),
        'closingTime': LocalTimeToJSON(value.closingTime),
        'maxBookingDays': value.maxBookingDays,
        'earliestPossiblePickup': (value.earliestPossiblePickup.toISOString()),
        'latestPossiblePickup': (value.latestPossiblePickup.toISOString()),
        'address': value.address,
        'phoneNumber': value.phoneNumber,
        'email': value.email,
    };
}

